import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";

const SpecialProducts = () => {
  const [specialProducts, setSpecialProducts] = useState([]);

  useEffect(() => {
    const fetchSpecialProducts = async () => {
      try {
        const response = await axiosInstance.get("/api/products/special");
        setSpecialProducts(response.data);
      } catch (error) {
        console.error("Error fetching special products:", error);
      }
    };

    fetchSpecialProducts();
  }, []);

  return (
    <div className="container mx-auto mt-8">
      <div className="flex mx-4 md:mx-auto text-center place-content-center mt-5">
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>

        <p className="text-center text-xl sm:text-2xl text-amber-600 font-bold mb-2 font-nav">
          {" "}
          Special
        </p>
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>
      </div>

      <p className="text-center font-bold font-roboto text-3xl sm:text-4xl mb-8">
        Special This Month
      </p>

      <div className="lg:mx-36 md:mx-auto grid grid-cols-2 mx-4 md:grid-cols-3 lg:grid-cols-3 gap-2 justify-center  md:w-5/6">
        {specialProducts.map((product, index) => (
          <div key={product.id} className="p-1 md:p-4">
            <Link to={`/product/${product._id}`} className="block">
              <div className="max-4 rounded overflow-hidden shadow-lg">
                <img
                  className="md:w-full lg:h-52 md:h-36 h-20 object-cover"
                  src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                  alt={product.name}
                />

                <div className="flex justify-between">
                  <div className="px-2 py-2 md:px-4 md:py-4 lg:px-6 lg:py-4">
                    <div className="text-sm lg:text-lg md:text-sm font-light font-heading text-amber-500">
                      {product.name}
                    </div>

                    <div className="flex items-center">
                      <p className="text-red-600 text-sm md:text-lg mr-2 line-through">
                        {product.originalprice}
                      </p>
                      <p className="text-gray-500 text-sm md:text-lg font-semibold">
                        {product.discountprice}
                      </p>
                    </div>
                    {/* Calculate and display the discount percentage */}
                    <p className="text-green-600 text-sm md:text-lg font-semibold">
                      Save{" "}
                      {(
                        ((product.originalprice - product.discountprice) /
                          product.originalprice) *
                        100
                      ).toFixed(2)}
                      %
                    </p>
                  </div>

                  <div className="mt-5 mr-1 ">
                    <div className="bg-amber-400 w-9 h-9 rounded-full">
                      <button class="material-symbols-outlined ml-2 ">
                        <Link to={`/product/${product._id}`}>
                          <FontAwesomeIcon
                            className="mt-2"
                            icon={faShoppingCart}
                            style={{ color: "white", fontSize: "16px" }}
                          />
                        </Link>
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecialProducts;
